module.exports = __webpack_public_path__ + "static/media/advantage3.edaf88cf.png";